export default "__VITE_ASSET__22ddd580__"